<template>
  <!-- 错发监控 -->
  <div class="Box">
    <el-card class="mb5">
      <el-form>
        <el-row type="flex" justify="left" style="flex-wrap: wrap">
          <el-col :span="9">
            <!--时间-->
            <el-form-item :label="$t('collectionCenter.val1')">
              <el-date-picker
                v-model="timeValue"
                :default-time="['00:00:00', '23:59:59']"
                :placeholder="$t('newOrder.SelectDatetime')"
                range-separator="~"
                style="width:95%" size="small"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="changeTime"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--  运单号   -->
            <el-form-item>
              <div class="selectLabel">
                <el-select v-model="queryForm.params.searchType" size="small" @change="typeChange">
                  <el-option :label="$t('newOrder.waybillNumber')" value="waybill" />
                  <el-option :label="$t('GlobalSetObj.ScanNumber')" value="scan" />
                </el-select>
              </div>
              <el-input
                v-model="inputValue"
                :placeholder="$t('newOrder.PreciseSearch1')"
                :rows="1" type="textarea" clearable
                style="width:95%" class="inputClass"
                @blur="BlockNewline"
                @keydown.enter.native="BlockNewline"
              />
            </el-form-item>
          </el-col>
          <!-- 预派送网点 -->
          <el-col :span="5">
            <el-form-item :label="$t('collectionCenter.mis6')">
              <ElSelectV2
                v-model="queryForm.params.preDeliverSiteIds"
                :options="preSiteList"
                :placeholder="$t('GlobalSetObj.all')"
                clearable filterable
                multiple collapse-tags
                remote :remote-method="getPreDeliverSite"
                style="width: 95%" size="small"
              />
            </el-form-item>
          </el-col>
          <!-- 所属HUB -->
          <el-col :span="5">
            <el-form-item :label="$t('collectionCenter.val13')">
              <ElSelectV2
                v-model="queryForm.params.preDeliverDepartmentIds"
                :options="siteList"
                :placeholder="$t('GlobalSetObj.all')"
                clearable filterable multiple
                collapse-tags
                style="width: 95%" size="small"
              />
            </el-form-item>
          </el-col>
          <!-- 所属大区 -->
          <el-col :span="5">
            <el-form-item :label="$t('collectionCenter.val14')">
              <el-select
                v-model="queryForm.params.preDeliverRegionIds"
                :placeholder="$t('GlobalSetObj.all')"
                clearable filterable multiple
                collapse-tags
                size="small" style="width: 95%"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('collectionCenter.val3')">
              <el-select
                v-model="queryForm.params.operateRegionIds"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable filterable multiple
                collapse-tags
                size="small" style="width: 95%"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('collectionCenter.val4')">
              <ElSelectV2
                v-model="queryForm.params.operateSiteIds"
                :options="siteList"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable filterable multiple
                collapse-tags
                style="width: 95%" size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="margin-bottom: 20px">
        <!--搜索-->
        <el-button size="small" type="primary" @click="search">{{ $t('newOrder.search') }}</el-button>
        <!--重置-->
        <el-button size="small" type="info" @click="resetForm">{{ $t('newOrder.reset') }}</el-button>
        <!--导出-->
        <el-button size="small" type="primary" @click="exportAll">{{ $t('newOrder.export') }}</el-button>
      </div>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        border
        style="width: 100%"
      >
        <el-table-column :label="$t('operationCenter.ind')" width="60px" align="center">
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in tableHeaderList"
          :key="index"
          align="center"
          :label="item.label"
          :min-width="item.cloWidth"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot="header">
            <div v-if="item.prop === 'remainingSlaTimeStr'">
              <span>{{ $t('collectionCenter.val11') }}</span>
              <el-tooltip
                class="item" effect="dark" :content="$t('collectionCenter.val12')"
                placement="top"
              >
                <span class="deliveryTimesTips">?</span>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            <div>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @size-change="search"
          @current-change="searchPage"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  getRegionOptions,
  getSiteTransfer,
  routeDeviationMonitorPage,
  routeDeviationMonitorExport
} from '@/api/orderApi';
import { goResourceTaskList } from '@/utils/goExportList';
import dayjs from 'dayjs';
import ElSelectV2 from 'el-select-v2';
import { siteFuzzyQuery } from '@/api/lanshou';

export default {
  name: 'WrongDelivery',
  components: {
    ElSelectV2
  },
  data() {
    return {
      preSiteList: [],
      inputValue: '',
      timeValue: [],
      regionList: [],
      siteList: [],
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          startDate: '',
          endDate: '',
          searchType: 'waybill',
          waybillNumberList: [],
          scanOrderNumberList: [],
          operateRegionIds: [],
          operateSiteIds: [],
          preDeliverSiteIds: [],
          preDeliverDepartmentIds: [],
          preDeliverRegionIds: []
        }
      },
      total: 0,
      tableData: [],
      tableHeaderList: [
        // 统计日期
        { label: this.$t('collectionCenter.val1'), prop: 'dataDate', cloWidth: '160' },
        // 运单号
        { label: this.$t('newOrder.waybillNumber'), prop: 'waybillNumber', cloWidth: '200' },
        // 扫描单号
        { label: this.$t('GlobalSetObj.ScanNumber'), prop: 'scanOrderNumber', cloWidth: '200' },
        // 预派送网点
        { label: this.$t('collectionCenter.mis6'), prop: 'preDeliverSiteName', cloWidth: '200' },
        // 所属HUB
        { label: this.$t('collectionCenter.val13'), prop: 'preDeliverDepartmentName', cloWidth: '200' },
        // 所属大区
        { label: this.$t('collectionCenter.val14'), prop: 'preDeliverRegionName', cloWidth: '200' },
        // 错发入库大区
        { label: this.$t('collectionCenter.misroutedInboundRegion'), prop: 'actualArriveRegionName', cloWidth: '200' },
        // 错发入库网点
        { label: this.$t('collectionCenter.misroutedInboundBranch'), prop: 'actualArriveSiteName', cloWidth: '200' },
        // 错发操作大区
        { label: this.$t('collectionCenter.val3'), prop: 'operateRegionName', cloWidth: '160' },
        // 错发操作网点
        { label: this.$t('collectionCenter.val4'), prop: 'operateSiteName', cloWidth: '160' },
        // 错发装车时间
        { label: this.$t('collectionCenter.val6'), prop: 'loadTime', cloWidth: '160' },
        // 错发下一站
        { label: this.$t('collectionCenter.val7'), prop: 'nextSiteName', cloWidth: '160' },
        // 错发入库时间
        { label: this.$t('collectionCenter.val10'), prop: 'actualArriveTime', cloWidth: '160' },
        // 理应送达时间
        { label: this.$t('basicData.shouldDeliveredTime'), prop: 'expectedDeliveredTime', cloWidth: '160' },
        // 剩余时效时间
        { label: this.$t('collectionCenter.val11'), prop: 'remainingSlaTimeStr', cloWidth: '160' }
      ]
    };
  },
  created() {
    this.getTimer();
    this.getRegion();
    this.getState();
    this.getPreDeliverSite();
    this.search();
  },
  methods: {
    resetForm() {
      this.getTimer();
      this.queryForm.params = {
        startDate: this.timeValue[0],
        endDate: this.timeValue[1],
        searchType: 'waybill',
        waybillNumberList: [],
        scanOrderNumberList: [],
        operateRegionIds: [],
        operateSiteIds: [],
        preDeliverSiteIds: [],
        preDeliverDepartmentIds: [],
        preDeliverRegionIds: []
      };
      this.inputValue = '';
      this.search();
    },
    search() {
      this.queryForm.pageNumber = 1;
      this.searchPage();
    },
    searchPage() {
      routeDeviationMonitorPage(this.queryForm).then(rea => {
        if (rea.code === 200) {
          this.total = rea.data.total;
          this.tableData = rea.data.records;
        }
      });
    },
    exportAll() {
      routeDeviationMonitorExport(this.queryForm.params).then(res => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    changeTime(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm.params.startDate = '';
        this.queryForm.params.endDate = '';
        return;
      }
      this.queryForm.params.startDate = val[0];
      this.queryForm.params.endDate = val[1];
    },
    getTimer() {
      const today = dayjs().format('YYYY-MM-DD');
      const day = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
      this.timeValue = [day + ' 00:00:00', today + ' 23:59:59'];
      this.queryForm.params.startDate = day + ' 00:00:00';
      this.queryForm.params.endDate = today + ' 23:59:59';
    },
    // 大区
    getRegion() {
      getRegionOptions().then(res => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    getState() {
      getSiteTransfer().then((res) => {
        if (res.code === 200) {
          this.siteList = (res.data || []).map((item) => {
            return {
              value: item.id,
              label: item.name
            };
          });
        }
      });
    },
    typeChange() {
      this.inputValue = '';
      this.queryForm.params.waybillNumberList = [];
      this.queryForm.params.scanOrderNumberList = [];
    },
    BlockNewline() {
      this.$nextTick(() => {
        this.queryForm.params.waybillNumberList = [];
        this.queryForm.params.scanOrderNumberList = [];
        if (this.inputValue) {
          let lines = this.inputValue
            .split('\n')
            .filter(line => line.trim() !== '')
            .map(line => line.replace(/\s+/g, ''));
          if (lines.length > 2000) {
            lines = lines.slice(0, 2000);
            this.$message.warning(this.$t('collectionCenter.intercep2'));
          }
          this.inputValue = lines.join('\n');
          if (this.queryForm.params.searchType === 'waybill') {
            this.queryForm.params.waybillNumberList = lines;
          } else {
            this.queryForm.params.scanOrderNumberList = lines;
          }
        }
      });
    },
    // 预派送网点
    getPreDeliverSite(val) {
      const value = val || '';
      siteFuzzyQuery(value).then((res) => {
        if (res.code === 200) {
          this.preSiteList = (res.data || []).map((item) => {
            return {
              value: item.id,
              label: item.name
            };
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.Box{
  box-sizing: border-box;
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.inputClass ::v-deep .el-textarea__inner {
  max-height: 200px;
}
.selectLabel {
  line-height: 35px !important;
}
.selectLabel ::v-deep .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
  border: none;
  text-align: left;
  font-size: 14px;
  color: #4e5969;
  font-weight: 500;
}
.selectLabel ::v-deep .el-input__icon {
  line-height: 32px !important;
}
.deliveryTimesTips {
  display: inline-block;
  width: 15px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid #aaa;
  font-size: 12px;
}
</style>
